export const SET_ACTIVE_EXCLUSION_TAB = 'SET_ACTIVE_EXCLUSION_TAB';
export const setActiveExclusionTab = (tab: string) => ({
  type: SET_ACTIVE_EXCLUSION_TAB,
  payload: tab,
});
interface IState {
  activeExclusionTab: string;
}
const initialState: IState = {
  activeExclusionTab: 'account',
};

export const exclusionListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_ACTIVE_EXCLUSION_TAB:
      return { ...state, activeExclusionTab: action.payload };
    default:
      return state;
  }
};
